function init(): void{
  const faqFeedbackModal = document.querySelectorAll<HTMLButtonElement>(".faq-feedback-modal");

  faqFeedbackModal.forEach(modal => {
    const form = modal.querySelector("form");

    modal.addEventListener("modal-closed", () => {
      const formStatusMessage = form.querySelector<HTMLElement>(".alert-block");
      form?.reset();
      const formMainBody = form.querySelector(".Form__MainBody");
      const footerCloseButton = modal.querySelector(".cta--primary.js-modal-close");

      if (formMainBody) {
        formMainBody.removeAttribute("style");
      }

      if (formStatusMessage) {
        formStatusMessage.classList.add("hide");
      }

      if (footerCloseButton) {
        footerCloseButton.classList.add('hidden');
      }
    });

    const listenFormSubmitted = () => {
      if (typeof window.$$epiforms === "function") {
        const epiFormsInstance = window.$$epiforms(form);
        if (epiFormsInstance && typeof epiFormsInstance.on === "function") {
          epiFormsInstance.on("formsSubmitted", () => {
            const footerCloseButton = modal.querySelector(".cta--primary.js-modal-close");

            if (footerCloseButton) {
              footerCloseButton.classList.remove("hidden");
            }
          });
        }
      }
    };

    listenFormSubmitted();
  });
}

export default { init };
